import { getConfig } from 'src/components/ImportCSV/get-import-config'
import type { RosterTransferKind } from '@sportninja/common/features/competition/operations/utils/rosterTransfer'

/**
 * The CSV template the import modal offers for each roster — the same choice
 * `ImportTeamRoster` makes for a single team (`roster` / `teamOfficials`).
 */
export const rosterImportTemplate = (kind: RosterTransferKind) => {
  const config = getConfig()
  return kind === 'teamOfficials' ? config.teamOfficials : config.roster
}
